// Optional sugar for locale authors whose language needs Slavic-style
// count-dependent noun forms — not required by the type system (a locale
// file is free to hand-roll its own logic), just saves re-deriving the same
// CLDR-ish rules in every file that needs them.

/** Serbian/Bosnian/Croatian/Macedonian/Rusyn-style: one/few/many, with the
 * standard "but not 11-14" exception on both the singular and paucal forms. */
export function pluralBcs(n: number, forms: [one: string, few: string, many: string]): string {
  const [one, few, many] = forms;
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return few;
  return many;
}

/** Slovak/Slovenian-style: 1 -> one, 2-4 -> few, else -> many (no mod-100 exception). */
export function pluralSk(n: number, forms: [one: string, few: string, many: string]): string {
  const [one, few, many] = forms;
  if (n === 1) return one;
  if (n >= 2 && n <= 4) return few;
  return many;
}

/** Romanian-style: 1 -> one, 0 or 2-19 -> few, else -> many. */
export function pluralRo(n: number, forms: [one: string, few: string, many: string]): string {
  const [one, few, many] = forms;
  if (n === 1) return one;
  const mod100 = n % 100;
  if (n === 0 || (mod100 >= 1 && mod100 <= 19)) return few;
  return many;
}
